export const CLOSE_MAIN_MODAL = 'CLOSE_MAIN_MODAL';

export const OPEN_MAIN_MODAL = 'OPEN_MAIN_MODAL';

export const TOGGLE_ITEM_MODAL = 'TOGGLE_ITEM_MODAL';

export const CHANGE_ITEM_MODAL_TAB = 'CHANGE_ITEM_MODAL_TAB';
